export default function shiftDays(numberOfDays: number, date: Date) {
  const result = new Date(date)
  result.setDate(result.getDate() + numberOfDays)

  return result
}
